import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MplButton, MplModal } from '@mopla/ui';
import { FailedAnim } from '@mopla/ui';

interface IProps {
	open: boolean;
	close: VoidFunction;
}
export const JobTicketExistsModal: FC<IProps> = ({ open, close }) => {
	const { t } = useTranslation('dticket');

	const handleClose = () => {
		localStorage.removeItem('spenditToken');
		close();
	};
	return (
		<MplModal
			open={open}
			icon={<FailedAnim loop />}
			testId="JobTicketExistsModal-MplModal"
			title={t('subscription_management.modal.header.jobticket_exists')}
			content={t('subscription_management.modal.jobticket_exists_description')}
			buttons={
				<MplButton fullWidth onClick={handleClose}>
					{t('subscription_management.button.okay')}
				</MplButton>
			}
		/>
	);
};
